import React, {
  ChangeEvent,
} from 'react';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from 'pages/Dashboard/components/Input/Radio';
import {
  CommonOption,
  EventType,
} from 'pages/Dashboard/pages/Appointments/pages/List/types/appointment';
import {
  pluralize,
} from '@populateui/utils';
import {
  eventTypeTitles,
} from 'pages/Dashboard/pages/Appointments/pages/List/utils/helper';

const getActionsOptions = (type: EventType): CommonOption[] => [{
  id: 'current',
  label: `This ${eventTypeTitles[type]} only`,
}, {
  id: 'following',
  label: `This and following ${pluralize(eventTypeTitles[type], 0, false)}`,
}, {
  id: 'all',
  label: `All ${pluralize(eventTypeTitles[type], 0, false)}`,
}];

export type Props = {
  value: string | null;
  onChange: (e: ChangeEvent<HTMLInputElement>, value: string) => void;
  type: EventType;
};

export default function RecurringActionOptions({
  value,
  onChange,
  type,
}: Props) {
  return (
    <RadioGroup
      className="flex flex-col gap-2 pl-2"
      onChange={onChange}
      value={value}
    >
      {getActionsOptions(type)
        .map(({ id, label }) => (
          <Radio
            key={id}
            label={label}
            value={id.toString()}
          />
        ))}
    </RadioGroup>
  );
}
